var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMirroringScreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.1665 50.75H37.8332C36.8765 50.75 36.0832 49.9567 36.0832 49C36.0832 48.0433 36.8765 47.25 37.8332 47.25H40.1665C46.1865 47.25 50.0832 43.3533 50.0832 37.3333V18.6667C50.0832 12.6467 46.1865 8.75 40.1665 8.75H16.8332C10.8132 8.75 6.9165 12.6467 6.9165 18.6667V21C6.9165 21.9567 6.12317 22.75 5.1665 22.75C4.20984 22.75 3.4165 21.9567 3.4165 21V18.6667C3.4165 10.64 8.8065 5.25 16.8332 5.25H40.1665C48.1932 5.25 53.5832 10.64 53.5832 18.6667V37.3333C53.5832 45.36 48.1932 50.75 40.1665 50.75Z",
    fill: "#6B6B6B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1769 49.1399C28.3136 49.1399 27.5669 48.4866 27.4502 47.6233C26.1669 37.6366 18.8869 30.3333 8.8769 29.05C7.92023 28.9333 7.24358 28.0466 7.36025 27.0899C7.47691 26.1332 8.36357 25.4566 9.32024 25.5733C20.9402 27.0666 29.4336 35.5366 30.9036 47.1566C31.0202 48.1133 30.3436 48.9999 29.3869 49.1166C29.3403 49.1399 29.2469 49.1399 29.1769 49.1399Z",
    fill: "#6B6B6B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3365 51.6366C20.4732 51.6366 19.7265 50.9832 19.6099 50.1199C18.6999 43.0032 13.4965 37.7999 6.37986 36.8899C5.4232 36.7732 4.74651 35.8865 4.86318 34.9299C4.97984 33.9732 5.86654 33.2966 6.8232 33.4132C15.5732 34.5332 21.9432 40.9265 23.0632 49.6532C23.1798 50.6099 22.5032 51.4965 21.5465 51.6132C21.4765 51.6365 21.4065 51.6366 21.3365 51.6366Z",
    fill: "#6B6B6B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4705 53.1299C11.6072 53.1299 10.8605 52.4766 10.7438 51.6133C10.3472 48.4633 8.03719 46.1532 4.88719 45.7566C3.93052 45.6399 3.25383 44.7532 3.3705 43.7966C3.48717 42.8399 4.37386 42.1633 5.33053 42.2799C10.0439 42.8866 13.6139 46.4566 14.2205 51.1699C14.3372 52.1266 13.6605 53.0132 12.7038 53.1299C12.6338 53.1299 12.5639 53.1299 12.4705 53.1299Z",
    fill: "#6B6B6B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMirroringScreen);
export default __webpack_public_path__ + "static/media/mirroring-screen.b5af2ddb75d1d8b44b457a1357faab10.svg";
export { ForwardRef as ReactComponent };